import { FormField } from "../../../FormEngine/types";
import { z } from "zod";


export const weightHealthSchema: FormField[] = [
  {
    type: "radio",
    name: "botheredByWeight",
    title: "Feelings About Your Weight",
    description: "Do you ever feel bothered by your weight?",
    fieldProps: {
      options: [
        "Very often",
        "Somewhat often",
        "Occasionally",
        "Rarely",
        "Never",
      ].map(opt => ({ label: opt, value: opt })),
    },
  },
  {
    type: "radio",
    name: "discussWeight",
    title: "Discuss with Your Clinician",
    description: "Would you like to discuss your weight with your clinician?",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      sx: { flexDirection: "row", gap: 1 },
    },
  },
  // Conditional fields
  {
    type: "multi-select",
    name: "weightLossMethods",
    title: "Weight Loss Methods",
    description: "Have you used any of the following to lose weight? (select all that apply)",
    options: [
      "Weight loss medicine",
      "Weight loss surgery",
      "Exercise/diets",
    ].map(opt => ({ label: opt, value: opt })),
    conditional: {
      label: "discussWeight",
      values: [true],
      resetOnHide: true,
    },
  },
  {
    type: "radio",
    name: "eatingDisorder",
    title: "Eating Disorder",
    description: "Have you ever been diagnosed with, or do you currently have or suspect you may have an Eating Disorder?",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      sx: { flexDirection: "row", gap: 1 },
    },
    conditional: {
      label: "discussWeight",
      values: [true],
      resetOnHide: true,
    },
    rule: z.boolean(),
  },
  {
    type: "radio",
    name: "pregnant",
    title: "Pregnancy",
    description: "Are you currently pregnant or breastfeeding?",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No (or not applicable)", value: false },
      ],
      sx: { flexDirection: "row", gap: 1 },
    },
    conditional: {
      label: "discussWeight",
      values: [true],
      resetOnHide: true,
    },
    rule: z.boolean(),
  },
  {
    type: "radio",
    name: "pregnant",
    title: "Pregnancy Planning",
    description: "Do you plan to become pregnant in the next 6 months?",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No (or not applicable)", value: false },
      ],
      sx: { flexDirection: "row", gap: 1 },
    },
    conditional: {
      label: "discussWeight",
      values: [true],
      resetOnHide: true,
    },
    rule: z.boolean(),
  },
];

export default weightHealthSchema;